import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import HeaderDescription from "../../../../components/commons/HeaderDescription";
import { formatDateWithDays } from "../../../../helpers/formatDateWithDays";
import DisplayNameInput from "./DisplayNameInput";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import { adminOnboardingPersonalInfoSchema } from "../../../../validations/adminOnboarding";
import mobioApi from "../../../../services";
import { toastMessage } from "../../../../helpers/toastMessage";

const PersonalInfo = ({ onboardingData, CheckDisplayName, token }) => {
  return (
    <div>
      {/* form */}
      <div className="width-ful">
        <Formik
          initialValues={{
            displayName: onboardingData
              ? onboardingData?.user?.displayName || ""
              : "",
            fullName: onboardingData
              ? onboardingData?.user?.fullName || ""
              : "",
            phoneNumber: onboardingData
              ? onboardingData?.user?.phoneNumber || ""
              : "",
            email: onboardingData ? onboardingData?.user?.email || "" : "",
            address: onboardingData ? onboardingData?.user?.address || "" : "",
            addressLineTwo: onboardingData
              ? onboardingData?.user?.addressLineTwo || ""
              : "",
            postalCode: onboardingData
              ? onboardingData?.user?.postalCode || ""
              : "",
            activeCity: onboardingData
              ? onboardingData?.user?.activeCity || ""
              : "",
            activeCountry: onboardingData
              ? onboardingData?.user?.activeCountry || ""
              : "",
            role: onboardingData ? onboardingData?.user?.role || "" : "",
            verified: onboardingData
              ? onboardingData?.user?.verified
                ? "1"
                : "0"
              : "",
            registrationDate: onboardingData
              ? onboardingData?.user?.createdAt
                ? formatDateWithDays(onboardingData?.user?.createdAt)
                : ""
              : "",
          }}
          validationSchema={adminOnboardingPersonalInfoSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const payload = {
                userId: onboardingData?.user?.id,
                fullName: values.fullName,
                phoneNumber: values.phoneNumber,
                email: values.email,
                address: values.address,
                addressLineTwo: values.addressLineTwo,
                postalCode: values.postalCode,
                activeCity: values.activeCity,
                activeCountry: values.activeCountry,
                role: values.role,
                verified: values.verified,
                updateStatus: "personalInfo",
              };

              const api = mobioApi(token);
              const response = await api.onboardingPersonalInfoUpdate(payload);
              if (response?.data?.success) {
                toastMessage(
                  "success",
                  response?.data?.msg || "User data update successfully"
                );

                onboardingData.user.fullName = values.fullName;
                onboardingData.user.phoneNumber = values.phoneNumber;
                onboardingData.user.email = values.email;
                onboardingData.user.address = values.address;
                onboardingData.user.addressLineTwo = values.addressLineTwo;
                onboardingData.user.postalCode = values.postalCode;
                onboardingData.user.activeCity = values.activeCity;
                onboardingData.user.activeCountry = values.activeCountry;
                onboardingData.user.role = values.role;
                onboardingData.user.verified =
                  values.verified === "1" ? true : false;
              }
            } catch (error) {
              toastMessage("error", error?.response?.data.msg);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <div className="bg-white main-section-spacing-md border-radius-8">
                <HeaderDescription
                  heading="Personal Information"
                  description="Fill in your personal details below."
                />

                <div className="mt-20">
                  {/* Display Name + Full Name */}
                  <div className="flex align-item-center gap-32">
                    <div className="flex-1">
                      <DisplayNameInput
                        CheckDisplayName={CheckDisplayName}
                        token={token}
                        onboardingData={onboardingData}
                      />
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Full Name</label>
                        <Field
                          type="text"
                          name="fullName"
                          placeholder="Enter Full Name"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="fullName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Phone Number + Email */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Phone Number</label>
                        <Field
                          type="text"
                          name="phoneNumber"
                          placeholder="Enter Phone Number"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="phoneNumber"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Email</label>
                        <Field
                          type="text"
                          name="email"
                          placeholder="Enter Email Address"
                          className="type-input-focus"
                          disabled={true}
                        />
                        <ErrorMessage
                          name="email"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Address Line 1</label>
                        <Field
                          type="text"
                          name="address"
                          placeholder="Enter Address Line 1"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="address"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Address Line 2</label>
                        <Field
                          type="text"
                          name="addressLineTwo"
                          placeholder="Enter Address Line 2"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="addressLineTwo"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Postal + City */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Postal Code</label>
                        <Field
                          type="text"
                          name="postalCode"
                          placeholder="Enter Postal Code"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="postalCode"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Active City</label>
                        <Field
                          type="text"
                          name="activeCity"
                          placeholder="Enter Active City"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="activeCity"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Country + Role Dropdown */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Active Country</label>
                        <Field
                          type="text"
                          name="activeCountry"
                          placeholder="Enter Active Country"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="activeCountry"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Role</label>
                        <Field
                          as="select"
                          name="role"
                          className="type-input-focus"
                        >
                          <option value="">Select Role</option>
                          <option value="Driver">Driver</option>
                          <option value="Dispatcher">Dispatcher</option>
                        </Field>
                        <ErrorMessage
                          name="role"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Verified + Created At */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Verification Status</label>
                        <Field
                          as="select"
                          name="verified"
                          className="type-input-focus"
                        >
                          <option value="">Select Status</option>
                          <option value="1">Verified</option>
                          <option value="0">Not Verified</option>
                        </Field>
                        <ErrorMessage
                          name="verified"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Registration Date</label>
                        <Field
                          type="text"
                          name="registrationDate"
                          className="type-input-focus"
                          value={values.registrationDate}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex align-item-center justify-content-end mt-42">
                    <MOButtonV2
                      type="submit"
                      text="SAVE PERSONAL INFORMATION"
                      textColor="#ffffff"
                      radius={4}
                      widthSize={200}
                      height={42}
                      padding={"10px 12px 10px 12px"}
                      backgroundColor="#29AEE6"
                      fontSize={12}
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PersonalInfo;
